import { useState } from 'react';
import { MapPin, Phone, Clock, Mail, Send } from 'lucide-react';

const services = ['Yoga', 'Meditação', 'Massagem Terapêutica', 'Nutrição', 'Plano Premium', 'Informação Geral'];

export default function Contact() {
  const [form, setForm] = useState({ nome: '', email: '', telefone: '', servico: '', mensagem: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 4000);
    setForm({ nome: '', email: '', telefone: '', servico: '', mensagem: '' });
  };

  return (
    <section id="contacto" className="py-28 bg-cream">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20 reveal">
          <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-4">Fala connosco</p>
          <h2 className="font-playfair italic text-5xl font-light text-ink">Contacto</h2>
          <div className="w-12 h-px bg-sage mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Info */}
          <div className="reveal space-y-8">
            <div>
              <h3 className="font-playfair text-2xl font-medium text-ink mb-4">Visita-nos</h3>
              <p className="font-dm text-base text-ink-light leading-relaxed max-w-sm">
                Encontra-nos no coração de Lisboa, num espaço cuidadosamente criado para ser o teu refúgio de serenidade.
              </p>
            </div>

            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-beige-light flex items-center justify-center flex-shrink-0">
                  <MapPin size={16} className="text-sage" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-dm text-sm font-medium text-ink">Morada</p>
                  <p className="font-dm text-sm text-ink-light mt-0.5">Rua da Paz, 42 · 1200-320 Lisboa</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-beige-light flex items-center justify-center flex-shrink-0">
                  <Phone size={16} className="text-sage" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-dm text-sm font-medium text-ink">Telefone</p>
                  <p className="font-dm text-sm text-ink-light mt-0.5">+351 213 456 789</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-beige-light flex items-center justify-center flex-shrink-0">
                  <Mail size={16} className="text-sage" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-dm text-sm font-medium text-ink">Email</p>
                  <p className="font-dm text-sm text-ink-light mt-0.5">hello@aurawellness.pt</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-beige-light flex items-center justify-center flex-shrink-0">
                  <Clock size={16} className="text-sage" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-dm text-sm font-medium text-ink">Horário</p>
                  <p className="font-dm text-sm text-ink-light mt-0.5">Seg–Sex: 07:00–21:00</p>
                  <p className="font-dm text-sm text-ink-light">Sáb–Dom: 09:00–18:00</p>
                </div>
              </div>
            </div>

            {/* Map placeholder */}
            <div className="rounded-2xl overflow-hidden border border-beige/40 h-48 bg-beige-light/40 flex items-center justify-center relative">
              <div className="text-center">
                <MapPin size={28} className="text-sage mx-auto mb-2" strokeWidth={1} />
                <p className="font-dm text-xs text-ink-light">Rua da Paz, 42 · Lisboa</p>
              </div>
              <div className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage: 'repeating-linear-gradient(0deg, #D4C5A9 0px, #D4C5A9 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, #D4C5A9 0px, #D4C5A9 1px, transparent 1px, transparent 40px)',
                }}
              />
            </div>
          </div>

          {/* Form */}
          <div className="reveal">
            <div className="bg-white/70 rounded-3xl p-8 border border-beige/40 shadow-sm">
              {sent ? (
                <div className="text-center py-12">
                  <div className="w-14 h-14 rounded-full bg-sage/10 flex items-center justify-center mx-auto mb-4">
                    <Send size={22} className="text-sage" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-playfair text-xl font-medium text-ink mb-2">Mensagem enviada!</h3>
                  <p className="font-dm text-sm text-ink-light">Entraremos em contacto em breve.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="font-dm text-xs text-ink-light uppercase tracking-wide block mb-2">Nome *</label>
                      <input
                        type="text"
                        name="nome"
                        value={form.nome}
                        onChange={handleChange}
                        required
                        placeholder="O teu nome"
                        className="aura-input w-full bg-cream border border-beige rounded-xl px-4 py-3 font-dm text-sm text-ink placeholder:text-ink/30"
                      />
                    </div>
                    <div>
                      <label className="font-dm text-xs text-ink-light uppercase tracking-wide block mb-2">Telefone</label>
                      <input
                        type="tel"
                        name="telefone"
                        value={form.telefone}
                        onChange={handleChange}
                        placeholder="+351 ..."
                        className="aura-input w-full bg-cream border border-beige rounded-xl px-4 py-3 font-dm text-sm text-ink placeholder:text-ink/30"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="font-dm text-xs text-ink-light uppercase tracking-wide block mb-2">Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="o.teu@email.com"
                      className="aura-input w-full bg-cream border border-beige rounded-xl px-4 py-3 font-dm text-sm text-ink placeholder:text-ink/30"
                    />
                  </div>
                  <div>
                    <label className="font-dm text-xs text-ink-light uppercase tracking-wide block mb-2">Serviço de interesse</label>
                    <select
                      name="servico"
                      value={form.servico}
                      onChange={handleChange}
                      className="aura-input w-full bg-cream border border-beige rounded-xl px-4 py-3 font-dm text-sm text-ink cursor-pointer appearance-none"
                    >
                      <option value="">Selecciona um serviço</option>
                      {services.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="font-dm text-xs text-ink-light uppercase tracking-wide block mb-2">Mensagem *</label>
                    <textarea
                      name="mensagem"
                      value={form.mensagem}
                      onChange={handleChange}
                      required
                      rows={4}
                      placeholder="Como podemos ajudar-te?"
                      className="aura-input w-full bg-cream border border-beige rounded-xl px-4 py-3 font-dm text-sm text-ink placeholder:text-ink/30 resize-none"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-sage text-white py-3.5 rounded-full font-dm text-sm font-medium hover:bg-sage-dark transition-all duration-300 hover:shadow-lg hover:shadow-sage/20 cursor-pointer flex items-center justify-center gap-2"
                  >
                    <Send size={15} strokeWidth={2} />
                    Enviar Mensagem
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
